import * as ActionTypes from '../Constants/actionTypes';
import { jwtDecode } from 'jwt-decode';
import Cookies from 'js-cookie';

const initialState = {
  accessToken: Cookies.get('accessToken') || null,
  refreshToken: Cookies.get('refreshToken') || null,
  currentUser: null,
  isAuthenticated: !!Cookies.get('accessToken'),
  isLoading: false,
  errorMessage: null,
  passwordExpired: Cookies.get('passwordExpired') === 'true', // Use cookie
  confirmedPasswordExpired: Cookies.get('confirmedPasswordExpired') === 'true', // Use cookie
};

// Decode the initial access token if it's available and valid
if (initialState.accessToken) {
  try {
    initialState.currentUser = jwtDecode(initialState.accessToken);
  } catch (error) {
    console.error('Invalid access token during initialization', error);
    initialState.accessToken = null;
    initialState.refreshToken = null;
    initialState.isAuthenticated = false;
  }
}


const authReducer = (state = initialState, action) => {
  switch (action.type) {


    case ActionTypes.LOGIN_REQUEST:
      return { ...state, isLoading: true, errorMessage: null };


    case ActionTypes.LOGIN_SUCCESS:
      let loginUser = null;
      if (typeof action.payload.accessToken === 'string') {
        try {
          loginUser = jwtDecode(action.payload.accessToken);
        } catch (error) {
          console.error('Invalid access token', error);
        }
      }
      return {
        ...state,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        currentUser: loginUser,
        isAuthenticated: !!action.payload.accessToken,
        isLoading: false,
        passwordExpired: false, // Reset password expired flag on successful login
        temporaryToken: null, // Remove temporary token
        confirmedPasswordExpired: false, // Reset confirmation
      };


    case ActionTypes.PASSWORD_EXPIRED: // New case for password expiration
      Cookies.set('passwordExpired', true, { secure: true, sameSite: 'Strict' });
      Cookies.set('confirmedPasswordExpired', false, { secure: true, sameSite: 'Strict' });
      return {
        ...state,
        isAuthenticated: false,
        isLoading: false,
        errorMessage: action.payload.errorMessage,
        passwordExpired: true, // Set flag to true
        confirmedPasswordExpired: false,
        temporaryToken: action.payload.temporaryToken, // Store temporary token
      };


    case ActionTypes.CONFIRM_PASSWORD_EXPIRED:
      Cookies.set('confirmedPasswordExpired', true, { secure: true, sameSite: 'Strict' });
      return {
        ...state,
        confirmedPasswordExpired: true, // User confirmed, now allow redirect
      };

    case ActionTypes.CHANGE_PASSWORD_REQUEST_TEMP:
      return { ...state, isLoading: true, errorMessage: null };


    case ActionTypes.CHANGE_PASSWORD_REQUEST:
      return { ...state, isLoading: true, errorMessage: null };

    case ActionTypes.CHANGE_PASSWORD_SUCCESS_TEMP:
      Cookies.remove('passwordExpired');
      Cookies.remove('confirmedPasswordExpired');
      Cookies.remove('temporaryToken');
      return {
        ...state,
        isAuthenticated: false, // Require re-login
        isLoading: false,
        errorMessage: null,
        passwordExpired: false,
        confirmedPasswordExpired: false,
      };

    case ActionTypes.CHANGE_PASSWORD_FAILURE:
      return { ...state, isLoading: false, errorMessage: action.payload };

    case ActionTypes.CHANGE_PASSWORD_FAILURE_TEMP:
      return { ...state, isLoading: false, errorMessage: action.payload };


    case ActionTypes.LOGIN_FAILURE:
      return {
        ...state,
        isAuthenticated: false,
        isLoading: false,
        errorMessage: action.payload,
      };


    case ActionTypes.LOGOUT:
      Cookies.remove('passwordExpired');
      Cookies.remove('confirmedPasswordExpired');
      return {
        ...state,
        accessToken: null,
        refreshToken: null,
        currentUser: null,
        isAuthenticated: false,
        isLoading: false,
        temporaryToken: null, // Ensure temporary token is cleared on logout
      };


    case ActionTypes.REFRESH_TOKEN_SUCCESS:
      let refreshUser = null;
      if (typeof action.payload.accessToken === 'string') {
        try {
          refreshUser = jwtDecode(action.payload.accessToken);
        } catch (error) {
          console.error('Invalid access token', error);
        }
      }
      return {
        ...state,
        accessToken: action.payload.accessToken,
        currentUser: action.payload.userData,
        isAuthenticated: !!action.payload.accessToken,
      };
    default:
      return state;
  }
};


export default authReducer;
